module.exports = __webpack_public_path__ + "media/stylesheets/images/Naoto Yamashita-5981d02a49fabfbabca02e904a483ecf.jpg";